// extracted by mini-css-extract-plugin
export default {"content":"BTa9zoiiMU4qAgjv31dHrw=="};